var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-created-by-date"},[_c('div',{staticClass:"created-by"},[_vm._v(_vm._s(_vm.createdBy))]),_c('div',{staticClass:"created-at"},[_vm._v(_vm._s(_vm.formattedDateTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }